import React from 'react';
import { Icon } from './Icon.js';
export const IconCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polyline", { points: "4 11 8 15 16 5", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconCheck.js.map